module.exports = __webpack_public_path__ + "static/media/restaurante.16aae2f0.svg";